import { Component, EventEmitter, Input, Output } from '@angular/core'
import { PaginationModel } from '@spartacus/core'
import { PaginationComponent, PaginationItem } from '@spartacus/storefront'
import { CustomPaginationType } from '../modals/enum/custom-pagination.enum'
import { ICustomPagination } from '../modals/interface/custom-pagination.interface'

@Component({
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrls: ['./custom-pagination.component.scss'],
  standalone: false
})
export class CustomPaginationComponent extends PaginationComponent {
  @Output() changePage: EventEmitter<number> = new EventEmitter()

  @Input() override set pagination(data: ICustomPagination) {
    super.pagination = this.mapPagination(data)
  }

  override get pagination(): PaginationModel {
    return super.pagination
  }

  private mapPagination(data: ICustomPagination): PaginationModel {
    if (data.type === CustomPaginationType.CUSTOM) {
      return {
        currentPage: data.page,
        pageSize: data.count,
        sort: 'N/A',
        totalPages: data.totalPages,
        totalResults: data.totalCount
      }
    }
    return data
  }

  pageChange(page: PaginationItem): void {
    this.changePage.emit(page.number)
  }
}
